import { render } from "./UpdateHistoryView.vue?vue&type=template&id=a654bdf8&scoped=true"
import script from "./UpdateHistoryView.vue?vue&type=script&lang=js"
export * from "./UpdateHistoryView.vue?vue&type=script&lang=js"

import "./UpdateHistoryView.vue?vue&type=style&index=0&id=a654bdf8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a654bdf8"]])

export default __exports__